import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, Inject, Input, OnInit } from '@angular/core';


@Component({
  selector: 'app-dialog-report-question',
  templateUrl: './dialog-report-question.component.html',
  styleUrls: ['./dialog-report-question.component.css']
})
export class DialogReportQuestionComponent {

  result: any;
  constructor(@Inject(DIALOG_DATA) public data: any,
    private _dialogRef: DialogRef) {

  }

  ngOnInit(): void {
  }
  cancel() {
    this._dialogRef.close({ result: 'Close' });
  }
  Dought_In_Question(IsDought: any) {
    this._dialogRef.close({ result: 'success', IsDought });
  }
}
